import { useEffect, useCallback, useState } from "react";
import store, { actions, useTypedSelector } from "@/stores";
import _ from "lodash";
import { submit as _submit } from "@form/services/campaign";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";

export type SubmitError = {
  [key in string]: {
    type: "twitter" | "discord" | "sendingme" | "email";
    needFollow?: string[];
    needJoinSquad?: string[];
    needJoinServer?: string[];
    error_message?: string;
    needRetweet?: string;
    needLike?: string;
    verifyEmail?: string;
  };
};

export default function useVerifyCampaign(field?: string) {
  const [submiting, setSubmiting] = useState(false);
  const [submitError, setSubmitError] = useState<SubmitError | undefined>();
  const { result, form } = useTypedSelector((state) => {
    return state.campaignVerify;
  });

  useEffect(() => {
    if (field) {
      store.dispatch(actions.campaignVerify.register(field));
      return () => {
        store.dispatch(actions.campaignVerify.unRegister(field));
      };
    }
  }, [field]);

  const changeVerifyState = useCallback(
    (state: boolean) => {
      if (field) {
        store.dispatch(
          actions.campaignVerify.changeVerifyState({
            field,
            state,
          })
        );
      }
    },
    [field]
  );

  const changeForm = useCallback(
    (value: any) => {
      if (field) {
        store.dispatch(
          actions.campaignVerify.changeForm({
            field,
            value,
          })
        );
      }
    },
    [field]
  );

  const submit = useCallback(async (data: any) => {
    try {
      setSubmiting(true);
      setSubmitError(undefined);
      const res = await _submit(data);
      mixpanel.track("submit_form", {
        form_id: data.campaign_id,
        is_submit_success: true,
        name: data.campaign_name,
        source: data?.context?.source,
      });
      return res;
    } catch (e: any) {
      try {
        const message = JSON.parse(e.message);
        setSubmitError(message);
      } catch (err) {
        toast.error(e.message);
      }

      mixpanel.track("submit_form", {
        form_id: data.campaign_id,
        is_submit_success: false,
        submit_failed: e.message,
        name: data.campaign_name,
        source: data?.context?.source,
      });
      return false;
    } finally {
      setSubmiting(false);
    }
  }, []);

  let verified = true;
  for (let prop in result) {
    if (!result[prop]) {
      verified = false;
      break;
    }
  }

  return {
    changeVerifyState,
    result,
    verified,
    submit,
    submiting,
    submitError,
    changeForm,
    form,
  };
}
